import { analysisPipeline, getAnalysisWidgets } from "@/api/analysis";
import { types } from "./mutations";
import uuid from "uuid";

export default {
  /**
   * Fetches all the analysis widgets and groups them by the type of widgets
   */
  fetchAnalysisWidgets: async (
    { dispatch },
    { payload, clearAllRequests = false }
  ) => {
    // cancel all the existing requests and clear the request queue tokens
    if (clearAllRequests) {
      dispatch("cancelAnalysisRequests");
      dispatch("clearQueue");
    }
    // generate a request token and add it to queue
    const requestToken = uuid.v4();
    dispatch("addTokenToQueue", { token: requestToken });

    try {
      const response = await getAnalysisWidgets(payload);
      const {
        status,
        data: { data },
      } = response;
      // check the response
      if (status === 200 && data) {
        // create a segregated json object of all the widgets present in the response
        const widgets = data.reduce((result, widget) => {
          // check if there are any widgets in the result, if yes push to the type array
          if (
            result[widget.widget_type] &&
            result[widget.widget_type].length > 0
          ) {
            result[widget.widget_type].push(widget);
            return result;
          } else {
            // else register a new array and push it to that
            return Object.assign(result, {
              [widget.widget_type]: [widget],
            });
          }
        }, {});
        dispatch("removeTokenFromQueue", { token: requestToken });
        return widgets;
      } else {
        throw new Error("Request failed");
      }
    } catch (error) {
      dispatch("removeTokenFromQueue", { token: requestToken });
      console.error("Analysis requests failed", error);
      return null;
    }
  },

  /**
   * Cancels any or all analysis requests in progress
   */
  cancelAnalysisRequests: async () => {
    analysisPipeline.cancel("Cancelling analysis requests...");
  },

  fetchConsoleWidgets: async ({}, payload) => {},

  cancelConsoleRequests: async () => {},

  /**
   * Adds the token to the queue
   */
  addTokenToQueue: async ({ state, commit }, { token }) => {
    if (state.requestTokens && state.requestTokens.length > 0) {
      commit(types.SET_REQUEST_TOKENS, [...state.requestTokens, token]);
    } else {
      commit(types.SET_REQUEST_TOKENS, [token]);
    }
  },

  /**
   * Removes a request token from the queue
   */
  removeTokenFromQueue: async ({ state, commit }, { token }) => {
    if (state.requestTokens && state.requestTokens.length > 0) {
      commit(
        types.SET_REQUEST_TOKENS,
        state.requestTokens.filter(tk => tk !== token)
      );
    }
  },

  /**
   * Clears the request token queue
   */
  clearQueue: async ({ commit }) => {
    commit(types.SET_REQUEST_TOKENS, []);
  },

  /**
   * Resets the module by clearing all the widget requests
   */
  reset: ({ dispatch }) => {
    dispatch("cancelAnalysisRequests");
    dispatch("cancelConsoleRequests");
    dispatch("clearQueue");
  },
};
